import { useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";

export const useCategories = async () => {
  const [categories, setCategories] = useState<any[]>([]);
  
  const client_id: any = process.env.REACT_APP_GIPHY_STICKER_API_KEY;
  const gf = new GiphyFetch(client_id);
  
  const fetchedCategories = await gf.categories();
  setCategories(fetchedCategories.data);

  return fetchedCategories
};